<template>
  <div>
    <div
      v-if="!access"
      class="workload-block-layout"
    >
      <div class="container">
        <div class="title-wrapper">
          <div class="main-title">
            {{ locales('workload_access_title') }}
          </div>
          <div class="pricing-title-container">
            {{ locales(planTitle) }}
          </div>
        </div>
        <div class="desc">
          <div class="desc-text">
            {{ locales('workload_access_desc') }}
            <div class="learn_more">
              <a
                class="pricing-popup-link"
                :href="locales('workload_learn_more')"
                target="_blank"
                @click="linkClick"
              >{{ locales('help_read_more') }}</a>
              <webix-ui
                class="arrow-left"
                :config="icons.arrowLeft"
              />
            </div>
          </div>
        </div>
        <upgrade-btn
          v-if="isOwner"
          :feature="'workload'"
        />
        <div class="pic">
          <img
            :src="pic"
            alt=""
          >
        </div>
      </div>
    </div>
    <gantt-view
      v-else-if="isLoadedRequiredData"
      @ready="initGanttInstance"
    />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '$$log';
import pricingHelper from '../../../helpers/pricingHelper';

import upgradeBtn from '../../common/VueComponents/ugradeButton/upgradeButton.vue';
import svgIconForVue from '../../common/svgIconForVue';
import arrowLeft from '../../../svg/pricing/ic_arrow_left.svg';
import projectsModel from '$$projectModel';
import multiViewsProjects from '$$multiviewModel';
import rights from '../../../components/rights';
// import routerHelper from '../../../helpers/router';
import ganttViewConstructor from '../../ganttView/init';
import ganttView from '../../ganttView/ganttView.vue';
import app from '$$app';
import skeleton from './workloadSkeleton.vue';
import skeletonPopup from '../../common/VueComponents/popups/skeletonPopup/skeletonPopup.vue';
import LoadRequiredDataMixin from '../../../mixins/LoadRequiredData';

export default {
  name: 'Workload',
  components: {
    upgradeBtn,
    skeleton,
    skeletonPopup,
    ganttView,
  },
  mixins: [LoadRequiredDataMixin],
  data() {
    return {
      locales: __,
      // webixUI,
      pic: `${GT.cdn}/imgs/workload/blocked_im_workload.png`,
      icons: {
        arrowLeft: svgIconForVue(arrowLeft, 27, 16),
      },
      needTimeForLoading: false,
      skeletonText: 'workload_loading_popup',
    };
  },
  computed: {
    ...mapGetters({
      currentRoute: 'headerView/currentRoute',
    }),
    access() {
      return pricingHelper.checkPricingAccess('workload');
    },
    planTitle() {
      return pricingHelper.getPlanLocale('workload');
    },
    isOwner() {
      return rights.account.isOwner();
    },
  },
  created() {
    this.$store.dispatch('updateWindowParams', {
      visibility: 'visible',
    });
  },
  mounted() {
    this.$nextTick(() => {
      
    });
  },
  beforeCreate() {
    
  },
  beforeUnmount() {
    $$('messageUsForm').isShown() && $$('messageUsForm').hide();
  },
  methods: {
    linkClick() {
      userExtAnalytics.log('pricing_deadlock_learn_more_clicked', { type: 'workload' });
    },
    initGanttInstance() {
      const t = log.time('viewWorkload.initGanttInstance');
      const multiviewId = this.$route.params.multiviewID;
      const projectId = this.$route.params.projectId;
      let ganttIds = [];

      if (multiviewId) {
        ganttIds = multiViewsProjects.getItem(multiviewId)?.ganttIDs;
      }

      if (projectId) {
        ganttIds = [projectId];
      }

      if (this.$route.name === 'workload' || this.$route.name === 'workloadTaskRoute') {
        ganttIds = projectsModel.getAllProjects().map(o => o.gantt_id);
      }

      ganttViewConstructor.initGanttInstanceWorkload(ganttIds);
      app.trigger('gantt:progress:hide');
      t.end();
    },
  },
};
</script>

<style scoped src='./less/workloadVue.less'></style>
